import { useContext, useEffect, useState } from "react";
import CacheApiContext from "../context/cache-api-context";
import axios from "../axios";
import { ApiCallType, ServerResponse } from "../types/General";
import { ZodError } from "zod";

function useApiCall<T>({url, key, fallbackData, schemaValidator, deep, invalidateCache, skipValidationType,
        refreshSingal, avoidCancelPreviosRequest, customDataKey, headers = {}, onError}: ApiCallType) {

    const cacheApiCallContext = useContext(CacheApiContext);

    const [data, setData] = useState<unknown | null>(fallbackData);
    const [loading, setLoading] = useState(false);

  function resetData() {
    setData(null);
  }

  function setDataManually(data: any) {
    if (key) {
      cacheApiCallContext?.setCache(key, data);
      setData(data);
    }
  }

  useEffect(() => {
    if (!schemaValidator || !url || !key) return;

    const controller = new AbortController();

    setLoading(true);
    setData(fallbackData);

        if (cacheApiCallContext?.getCache(key) && !invalidateCache) {
            setData(cacheApiCallContext.getCache(key))
            setLoading(false)
        } else {
            axios.get(url, { signal: controller.signal, headers: headers })
                .then((res) => {
                    if (skipValidationType) {
                        setData((res as ServerResponse).data as T)
                        cacheApiCallContext?.setCache(key, (res as ServerResponse)?.data || fallbackData);
                    } else {
                        let parsedData = null;
                        if (deep)
                            parsedData = schemaValidator.parse((((res as ServerResponse).data) as ServerResponse)[customDataKey ? customDataKey as keyof ServerResponse : 'data']); 
                        else
                            parsedData = schemaValidator.parse((res as ServerResponse).data); 
                        
                        setData(parsedData);
                        cacheApiCallContext?.setCache(key, parsedData);
                    }
                })
                .catch((e) => {
                    console.log(e)
                    setData(fallbackData);
                    onError && onError();
                    if (e instanceof ZodError)
                        cacheApiCallContext?.setCache(key, fallbackData);
                })
                .finally(() => {
                    setLoading(false)
                })
        }

    return () => {
      !avoidCancelPreviosRequest && controller.abort();
    };
  }, [
    url,
    key,
    fallbackData,
    schemaValidator,
    invalidateCache,
    skipValidationType,
    refreshSingal,
  ]);

  return {
    data: data as T,
    loading,
    resetData,
    setLoading,
    setDataManually,
  };
}

export default useApiCall;
